module.exports = __webpack_public_path__ + "img/alert-ok.6c5143bf.png";